module.exports = __webpack_public_path__ + "img/2_60.1563ada3.png";